import React from 'react';

import DistrictMap from './pages/DistrictMap';

const App: React.FC = () => <DistrictMap />;

export default App;
